/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Get_In_TouchInputs */

const en_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get In Touch`)
};

const es_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const de_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt aufnehmen`)
};

const zh_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const ar_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const fr_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous contacter`)
};

const vi_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ`)
};

const sw_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana`)
};

const th_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเรา`)
};

const bs_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Javite nam se`)
};

const ja_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const ko_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

const pt_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato`)
};

const it_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const sv_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss`)
};

const nl_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact op`)
};

const da_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt os`)
};

const nb_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i kontakt`)
};

const fi_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const pl_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z nami`)
};

const ru_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться с нами`)
};

const tr_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bize ulaşın`)
};

const hi_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क करें`)
};

const id_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const ms_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const cs_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte nás`)
};

const el_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε μαζί μας`)
};

const he_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר`)
};

const af_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak ons`)
};

const hu_events_get_in_touch = /** @type {(inputs: Events_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépj kapcsolatba velünk`)
};

/**
* | output |
* | --- |
* | "Get In Touch" |
*
* @param {Events_Get_In_TouchInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_get_in_touch = /** @type {((inputs?: Events_Get_In_TouchInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Get_In_TouchInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_get_in_touch(inputs)
	if (locale === "de") return de_events_get_in_touch(inputs)
	if (locale === "zh") return zh_events_get_in_touch(inputs)
	if (locale === "ar") return ar_events_get_in_touch(inputs)
	if (locale === "fr") return fr_events_get_in_touch(inputs)
	if (locale === "vi") return vi_events_get_in_touch(inputs)
	if (locale === "sw") return sw_events_get_in_touch(inputs)
	if (locale === "th") return th_events_get_in_touch(inputs)
	if (locale === "bs") return bs_events_get_in_touch(inputs)
	if (locale === "ja") return ja_events_get_in_touch(inputs)
	if (locale === "ko") return ko_events_get_in_touch(inputs)
	if (locale === "pt") return pt_events_get_in_touch(inputs)
	if (locale === "it") return it_events_get_in_touch(inputs)
	if (locale === "sv") return sv_events_get_in_touch(inputs)
	if (locale === "nl") return nl_events_get_in_touch(inputs)
	if (locale === "da") return da_events_get_in_touch(inputs)
	if (locale === "nb") return nb_events_get_in_touch(inputs)
	if (locale === "fi") return fi_events_get_in_touch(inputs)
	if (locale === "pl") return pl_events_get_in_touch(inputs)
	if (locale === "ru") return ru_events_get_in_touch(inputs)
	if (locale === "tr") return tr_events_get_in_touch(inputs)
	if (locale === "hi") return hi_events_get_in_touch(inputs)
	if (locale === "id") return id_events_get_in_touch(inputs)
	if (locale === "ms") return ms_events_get_in_touch(inputs)
	if (locale === "cs") return cs_events_get_in_touch(inputs)
	if (locale === "el") return el_events_get_in_touch(inputs)
	if (locale === "he") return he_events_get_in_touch(inputs)
	if (locale === "af") return af_events_get_in_touch(inputs)
	if (locale === "hu") return hu_events_get_in_touch(inputs)
	return en_events_get_in_touch(inputs)
});